<template>
    <div class="system_page">
        <div style="width:82%;margin: 0 auto;padding-top:40px;">
            <div style="position:relative;font-size: 32px;font-weight:600;padding-bottom:15px;border-bottom: 1px solid #92dded;">
                汇升投研管理
                <img style="width:34px;margin-left:8px;" src="../assets/sangang2.png" >

                <div style="position:absolute;right:20px;top:5px;">
                    <img style="width:32px;" src="../assets/juxing3.png"/>
                    <img style="width:32px;" src="../assets/juxing1.png"/>
                    <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png"/>
                    <img style="width:32px;" src="../assets/juxing3.png"/>
                    <span style="font-size:16px;color:#3fa8c7;margin-left:10px;vertical-align: super;cursor:pointer;" @click="addTrend()">新增</span>
                </div>
            </div>
            <div style="display: flex;margin-top:20px;border-bottom:1px solid #e8eaed;padding-bottom:18px;" v-for="item in trends" :key="item">
                <div style="width:30%;">
                    <!-- <img style="width:90%;" src="../assets/huishengdongtai1.png"/> -->
                    <img style="width:90%;" :src="getImgUrl(item.imgId)"/>
                </div>
                <div style="width:70%;">
                    <div style="font-size:23px;font-weight:600;margin-top:15px;">
                        {{item.title}}
                    </div>
                    <div style="font-size:16px;color:#3fa8c7;margin-top:15px;display:flex;justify-content: space-between;">
                        <div>发布于：{{item.createdTime}}</div>
                        <div style="cursor: pointer;">
                            <span @click="editTrend(item)">编辑</span>
                            <span style="margin-left:20px;" @click="del(item)">删除</span>
                        </div>
                    </div>
                    <div style="font-size:16px;margin-top:30px;">{{item.content}}</div>
                </div>
            </div>
            <el-pagination
                style="margin-top:15px;text-align:center;"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="pageSize"
                layout=" prev, pager, next"
                :total="totalNum">
            </el-pagination>
        </div>

        <el-dialog :title="trendType" :append-to-body="true" :visible.sync="dialogVisible" :show-close="false" :close-on-click-modal="false" @before-close="reject" :center="true">
            <div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
                    <el-form-item label="文章名称" prop="name">
                        <el-input v-model="ruleForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="文章内容" prop="desc">
                        <el-input type="textarea" :rows="3" v-model="ruleForm.desc"></el-input>
                    </el-form-item>
                    <el-form-item label="文章链接" prop="url">
                        <el-input v-model="ruleForm.url"></el-input>
                    </el-form-item>
                    <el-form-item label="文章置顶">
                        <el-radio-group v-model="ruleForm.focus">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="上传文章封面">
                        <el-upload
                            ref="upload"
                            class="upload-demo"
                            drag
                            :http-request="uploadAvatar"
                            :before-upload="beforeAvatarUpload"
                            :on-remove="handleRemove"
                            :file-list="fileListDate"
                            action="#"
                            :limit="1"
                            accept=".jpg,.jpeg,.png,.doc,.docx,.pdf,.excel,.xlsx,.xls"
                        >
                            <i class="el-icon-upload" />
                            <div>
                            <div class="el-upload__text"><em>点击上传</em>，文件数量限制1个,大小限制10M</div>
                            <!-- <div slot="tip" class="el-upload__tip">文件不超过10M</div> -->
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer" style="font-size: 18px;cursor: pointer;">
                <div style="margin: 0 auto;width: 176px;height:50px;border-radius:25px;border:1px solid #d0f4ff;justify-content: center;display: flex;align-items: center;">
                    <div @click="accept" style="font-size:17px;font-weight:600;text-align:center;border-radius:21px;background:#3fa8c7;color:#ffffff;width:160px;height:42px;line-height:42px;cursor:pointer;">确 认
                    </div>
                </div>
                <!-- <div style="margin: 0 auto;background:#3fa8c7;padding:5px 10px;color: #ffffff;width:100px;border-radius: 15px;" >接 受</div> -->
                <div style="margin: 0 auto;margin-top:15px;border-bottom:2px solid #8e8686;color: #858282;padding-bottom:3px;width:50px;margin-bottom:10px;" @click="reject">取 消</div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { uploadImg, articleListAll, createArticle, updateArticle, delArticle } from '@/api/index'
    export default {
        name: 'Index',
        data() {
            return {
                photolData: {
                    userId: '10234',
                    materialType: '',
                    filePath: '',
                    dataType: '1'
                },
                handleType: 'add',
                // 图片列表
                fileListDate: [],
                dialogVisible: false,
                trendType: '编辑文章',
                locationUrl: 'http://www.hhhstz.com' + '/website_service/img/preview/',
                ruleForm: {
                    name: '',
                    desc: '',
                    focus: 0,
                    url: ''
                },
                rules: {
                    name: [
                        { required: true, message: '请输入名称', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
                    ],
                    desc: [
                        { required: true, message: '请填写内容', trigger: 'blur' }
                    ],
                    url: [
                        { required: true, message: '请填写链接', trigger: 'blur' }
                    ]
                },
                trends: [],
                imgId: '',
                currentItem: {},
                currentPage: 1, //默认显示第一页
                pageSize: 5, //默认每页显示10条
                totalNum: 0, //总页数
            }
        },
        methods: {
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val; //动态改变
            },
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.currentPage = val; //动态改变
                this.initData()
                this.timer = setInterval(() => {
                    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                    let ispeed = Math.floor(-osTop / 5)
                    document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                    if (osTop === 0) {
                        clearInterval(this.timer)
                    }
                }, 10)
            },
            getImgUrl(id) {
                return this.locationUrl + id
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === "image/jpg";
                const isPng = file.type==="image/png";
                const isJpeg=file.type==="image/jpeg";
            
                //1MB=1024*1024(1MB=1024KB 1KB=1024MB)
                const is2M = file.size / 1024 / 1024 < 10;
            
                //限制文件上传类型
                if (!isJPG && !isPng && !isJpeg) {
                    this.$message.error("上传图片只能是 png,jpg,jpeg 格式!");
                    return false
                }
            
                //限制文件上传大小
                if (!is2M) {
                    this.$message.error("上传图片大小不能超过10MB!");
                    return false
                }
            
                return true
            },
            accept() {
                this.dialogVisible = false
                if (this.handleType === 'add') {
                    let params = {
                        content: this.ruleForm.desc,
                        title: this.ruleForm.name,
                        linkUrl: this.ruleForm.url,
                        focus: this.ruleForm.focus,
                        imgId: this.imgId,
                        type: 1
                    }
                    // console.log(params)
                    createArticle(params)
                    .then(res => {
                        this.$message.success(res.message)
                        this.initData()
                        this.fileListDate = []
                    })
                } else {
                    let params = {
                        articleId: this.currentItem.articleId,
                        content: this.ruleForm.desc,
                        title: this.ruleForm.name,
                        linkUrl: this.ruleForm.url,
                        focus: this.ruleForm.focus,
                        imgId: this.imgId,
                        type: 1
                    }
                    updateArticle(params)
                    .then(res => {
                        this.$message.success(res.message)
                        this.initData()
                        this.fileListDate = []
                    })
                }
            },
            del(item) {
                this.$confirm('此操作将永久删除该文章, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // this.$message({
                    //     type: 'success',
                    //     message: '删除成功!'
                    // });
                    delArticle({articleId: item.articleId, type: 1})
                    .then(res => {
                        this.$message.success(res.message)
                        this.initData()
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            },
            reject() {
                this.dialogVisible = false
            },
            editTrend(item) {
                this.dialogVisible = true
                this.handleType = 'edit'
                this.trendType = '编辑文章'
                this.currentItem = item
                this.ruleForm = {
                    name: item.title,
                    desc: item.content,
                    focus: item.focus,
                    url: item.linkUrl
                }
                this.imgId = item.imgId
            },
            addTrend() {
                this.dialogVisible = true
                this.handleType = 'add'
                this.trendType = '新增文章'
            },
            uploadAvatar(data) {
                const formData = new FormData()
                this.fileListDate = []
                console.log('data', data)
                formData.append('file', data.file)
                // formData.append('userId', this.photolData.userId)
                // formData.append('materialType', this.photolData.materialType)
                console.log(formData, 'formData')
                // this.loading = true
                // 后台接口
                uploadImg(formData).then(response => {
                    this.fileListDate.push({ name: data.file.name, url: response.data.storageId })
                    this.imgId = response.data.storageId
                    // this.loading = false
                })
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            initData() {
                articleListAll({
                    pageNo: this.currentPage,
                    pageSize: this.pageSize,
                    type: 1
                })
                .then(res => {
                    this.trends = res.data.records
                    this.totalNum = res.data.sumCount
                })
            }
        },
        mounted() {
            this.initData()
            // alert(location.origin)
        },
        computed: {

        },
    }
</script>
<style>

.system_page .el-form-item__label {
    font-size:16px;
}
</style>


// WEBPACK FOOTER //
// src/components/loveholicManage.vue